// extracted by mini-css-extract-plugin
var _1 = "iGigD";
var _2 = "UkzG7";
var _3 = "BNIx4";
var _4 = "GNuFB";
export { _1 as "sidebar", _2 as "sidebarHorizontal", _3 as "sidebarVertical", _4 as "sidebarVerticalThreeQuarters" }
